/* ──────────────────────────────────────────────────────────────
 *  MoreActionsMenu — Three-dots menu with Explore / More Details
 *
 *  Renders a vertical-dots IconButton that opens a dropdown
 *  with "Explore Designs" and "More Details" items.
 * ────────────────────────────────────────────────────────────── */

import React, { useState, useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useUIStore } from '@/stores/useUIStore';

const MoreActionsMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openDialog = useUIStore((s) => s.openDialog);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleExplore = useCallback(() => {
    openDialog('exploreDialog');
    setAnchorEl(null);
  }, [openDialog]);

  const handleMoreDetails = useCallback(() => {
    openDialog('moreDetailsDialog');
    setAnchorEl(null);
  }, [openDialog]);

  return (
    <>
      <IconButton size="small" onClick={handleOpen} aria-label="More actions">
        <MoreVertIcon sx={{ fontSize: 20 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{paper: {sx: {width: 200,p: 1}}
        }}
      >
        <MenuItem onClick={handleExplore}>
          <ListItemText>Explore Designs</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMoreDetails}>
          <ListItemText>More Details</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default React.memo(MoreActionsMenu);
